import { useState } from "react";
import fileRandom from "./../../components/Data/dataStatic__";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported once in your app
import "./Proyecto.scss";
import RelatedProjects from "./RelatedProjects";
import { useParams } from "react-router-dom";

const Proyecto = () => {
  const { id, sub } = useParams();
  const fileJson = fileRandom[id.replace("-", "").replace("-", "")][sub];
  const fileJsonChildren = fileRandom[id.replace("-", "").replace("-", "")];
  const [show, isOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const handleClick = (index) => {
    isOpen(true);
    setPhotoIndex(index);
  };
  let number = 1;
  const order = () => {
    number++;
    if (number === 3) {
      number = 0;
      return "top";
    }
    return "";
  };
  return (
    <>
      <div className="container">
        <div className="main mt ml mr mb">
          <div className={`content_proyect container`}>
            <div className="row">
              <div className="col-12 mb-5">
                <h3>{fileJson.name}</h3>
                <p>Contacto email: jpf@jpfcine.cl</p>
                {fileJson["description"].map((item, index) => (
                  <p key={index}>{item}</p>
                ))}
              </div>
            </div>
            <div className="row">
              <>
                {fileJson &&
                  fileJson["children"].map((item, index) => (
                    <div className="col-12 col-sm-6 col-md-4" key={index}>
                      <div className={`recuadro ${order}`}>
                        <img
                          src={item?.name}
                          onClick={(e) => {
                            handleClick(index);
                          }}
                          alt=""
                        />
                      </div>
                    </div>
                  ))}
                <RelatedProjects fileJsonChildren={fileJsonChildren} />
                {show && (
                  <Lightbox
                    mainSrc={fileJson["children"][photoIndex]?.name}
                    nextSrc={
                      fileJson["children"][
                        (photoIndex + 1) % fileJson["children"].length
                      ]?.name
                    }
                    prevSrc={
                      fileJson["children"][
                        (photoIndex + fileJson["children"].length - 1) %
                          fileJson["children"].length
                      ]?.name
                    }
                    imageCaption={""}
                    onCloseRequest={() => isOpen(false)}
                    onMovePrevRequest={() =>
                      setPhotoIndex(
                        (photoIndex + fileJson["children"].length - 1) %
                          fileJson["children"].length
                      )
                    }
                    onMoveNextRequest={() =>
                      setPhotoIndex(
                        (photoIndex + 1) % fileJson["children"].length
                      )
                    }
                  />
                )}
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Proyecto;
